<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <CalculatorHeader>
        <h2>First-Time Buyer Mortgage Calculator</h2>
        <h5>NO CREDIT CHECKS!</h5>
        <h5>Complete your income details below to give yourselves an idea how much you may be able to borrow.</h5>
      </CalculatorHeader>
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="calculator-container">

            <div @keyup="resetCalculation" @change="resetCalculation">

              <BooleanChoiceButtons
                  fieldText="Number of Applicants"
                  buttonTextLeft="1"
                  buttonTextRight="2"
              >
                <template v-slot:left>
                  <input type="radio" v-model="applicantsCount" value=1>
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="applicantsCount" value=2>
                </template>
              </BooleanChoiceButtons>

              <transition name="fade-x" mode="out-in">
                <InputElement
                    v-if="applicantsCount !== 0"
                    fieldText="Applicant 1 annual income (including benefits)?*"
                >
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome1"/>
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <InputElement
                    v-show="applicantsCount == 2"
                    fieldText="Applicant 2 annual income (including benefits)?*"
                >
                  <InputTypeNumber currencyPlaceholder v-model="annualIncome2"/>
                </InputElement>
              </transition>

              <transition name="scale-in" mode="out-in">
                <ReturnedValueBox
                    class="mb-5"
                    text="Your household income is: "
                    :value="householdIncome"
                    v-if="householdIncome > 0"
                    :innerElement=true
                />
              </transition>

              <transition name="fade-x" mode="out-in">
                  <div class="row mt-5" v-if="( annualIncome1 > 0  ) && householdIncome > 0">
                      <div class="col-md-6 col-lg-4 fw-bold">Why are you using the calculator today</div>
                      <div class="col-md-6 col-lg-8 fcs-grid-long">
                          <DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1"></DropdownMenu>
                      </div>
                  </div>
              </transition>   

              <transition name="fade-x" mode="out-in">
                  <div class="row mt-5 mb-5" v-if="( annualIncome1 > 0  ) && householdIncome > 0">
                      <div class="col-md-6 col-lg-4 fw-bold">When will you be ready to move forward?</div>
                      <div class="col-md-6 col-lg-8 fcs-grid-long">
                          <DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2"></DropdownMenu>
                      </div>
                  </div>
              </transition> 

              <!-- <transition name="fade-x" mode="out-in">
                <InputElement
                    v-if="( annualIncome1 > 0  ) && householdIncome > 0"
                    fieldText="Name"
                >
                  <input class="form-control calc-form-control" type="text" v-model="listName">
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                  <InputElement
                      v-if="( annualIncome1 > 0  ) && householdIncome > 0"
                      fieldText="Email Address"
                  >
                      <input class="form-control calc-form-control" type="email" v-model="emailAddress">
                  </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <div class="row align-items-center" v-if="( annualIncome1 > 0  ) && householdIncome > 0">
                    <div class="col-md-1">
                        <input type="checkbox" id="privacy" v-model="consent" >
                    </div>
                    <div class="col-md-11">
                        <label for="privacy">I consent to my personal information being processed in accordance with Just Mortgage Brokers <a href="/privacy-policy/" target="_blank">Privacy Policy</a></label>
                    </div>
                </div>
              </transition> -->

              <transition name="scale-in" mode="out-in">
                <div
                    v-if="( annualIncome1 > 0  ) && householdIncome > 0"
                    class="text-center mt-5 mb-3"
                >
                  <div class="btn btn-secondary" @click="calculate">CALCULATE</div>
                </div>
              </transition>

            </div>

            <transition name="fade-y" mode="out-in">
              <div
                  v-if="calcCompleted"
                  class="mt-5"
                  ref="resultsContainer"
              >

                <ResultsContainer class="mb-3">
                  <h6>Your estimated maximum borrowing amount is: approximately</h6>
                  <span class="fcs-price">£{{ formatNumberOutput(requiredLoanValue) }}</span>
                </ResultsContainer>

                <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody" />

              </div>
            </transition>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import ReturnedValueBox from '@/components/utilities/returnedValueBox.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    CalculatorHeader,
    DropdownMenu,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    ReturnedValueBox,
    SubmissionForm
  },
  data() {
    return {
      calculatorName: 'first-time-buyer-calculator',
      applicantsCount: 0,
      annualIncome1: null,
      annualIncome2: null,
      requiredLoanValue: 0,
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      dropdownOptionsReason: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
        {
          value: "I'm not ready for a mortgage but am curious about what I could borrow",
          text: "I'm not ready for a mortgage but am curious about what I could borrow"
        },
        {
          value: "I'm starting to save for a house and want to know what to aim for",
          text: "I'm starting to save for a house and want to know what to aim for"
        },
        {
          value: "I need to understand a what I can afford before house shopping",
          text: "I need to understand a what I can afford before house shopping"
        },



      ],

      dropdownOptionsMove: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "12+ months", text: "12+ months"},
        {value: "6-12 months", text: "6-12 months"},
        {value: "In the next 3 months", text: "In the next 3 months"},
        {value: "As soon as possible", text: "As soon as possible"},
      ],
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      this.applicantsCount > 0
          ? this.applicantsCount === 2 ? this.requiredLoanValue = this.householdIncome * 5.5 : this.requiredLoanValue = this.householdIncome * 5.5
          : this.requiredLoanValue = 0
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
                  var newReasonSubmission = new FormData();
                  var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    resetCalculation() {
      this.calcCompleted = false
      if (this.applicantsCount === "0" ) {
        this.annualIncome1 = null
        this.annualIncome2 = null
      }
      if (this.applicantsCount === "1" ) { this.annualIncome2 = null }
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    }
  },
  computed: {
    householdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    collateMessageBody() {
      const calculatorData =
          {
            calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
            calculatorResults:
                `
					Applicant 1 Annual Income: £${this.formatEmptyMessageFields(this.annualIncome1)}
                    Applicant 2 Annual Income: £${this.formatEmptyMessageFields(this.annualIncome2)}
                    Household Annual Income: £${this.householdIncome}
                    Required Loan Value: £${this.requiredLoanValue}
                    Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
                `
          }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>